



















































import Vue from 'vue'
import iconPriceSvg from '../../../../../app/assets/images/web/categories/icon-feature-price.svg'
import iconCalendarSvg from '../../../../../app/assets/images/web/categories/icon-feature-calendar.svg'
import iconPaymentSvg from '../../../../../app/assets/images/web/categories/icon-feature-payment.svg'
import iconAiSvg from '../../../../../app/assets/images/web/categories/icon-feature-illustrator.svg'

export default Vue.extend({
  computed: {
    iconPrice() {
      return iconPriceSvg
    },
    iconCalendar() {
      return iconCalendarSvg
    },
    iconPayment() {
      return iconPaymentSvg
    },
    iconAi() {
      return iconAiSvg
    }
  }
})
